import { IGlobalState } from '../../../Root/store/appReducer'

export const getLoginInProgress = (state: IGlobalState) => state.login?.loginInProgress

// SSO email-first flow selectors
export const getLoginStep = (state: IGlobalState) => state.login?.step || 'email'
export const getLoginMethod = (state: IGlobalState) => state.login?.loginMethod
export const getSsoCompanyId = (state: IGlobalState) => state.login?.ssoCompanyId
export const getSsoCompanyName = (state: IGlobalState) => state.login?.ssoCompanyName
export const getSsoConfigId = (state: IGlobalState) => state.login?.ssoConfigId
export const getIsCheckingLoginMethod = (state: IGlobalState) => state.login?.isCheckingLoginMethod
